import { Button, Grid, IconButton, Paper, Stack } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import React from "react";
import styled from "styled-components";
import Tooltip from "@mui/material/Tooltip";
import namesAndHelpersObject from "./components/names-and-helpers-object";

const CustomPaper = styled(Paper)`
    border-radius: 26px;
    padding: 8px;
    // width: 180px;
`;

const ExpandButton = styled(Button)`
    font-size: 11px;
    margin-top: 12px;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const AnalysisNegligibleData = ({ data }) => {
    if (!data || data.length === 0) return null;
    const [visibleData, setVisibleData] = React.useState(true);
    const [showAll, setShowAll] = React.useState(false);
    return (
        <>
            <Stack
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                mb={2}
                style={{ width: "100%" }}
            >
                <Tooltip title="These are additional data that our the deep learning graph discovery model told us that they had no significant consistent causal link with lead time, or other variables affecting it.">
                    <p style={{ margin: 0 }}>Negligible data</p>
                </Tooltip>
                <IconButton
                    aria-label="view-neglible-data"
                    onClick={() => setVisibleData(!visibleData)}
                >
                    {visibleData ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </IconButton>
            </Stack>
            <Stack direction="column" mb={6} alignItems="center" justifyContent="center">
                {visibleData && (
                    <Grid container spacing={2}>
                        {data.slice(0, showAll ? data.length : 15).map((item) => {
                            return (
                                <Grid item key={item}>
                                    <CustomPaper>
                                        <p style={{ margin: 0, fontSize: "11px" }}>
                                            {(namesAndHelpersObject[item] || {}).name || item}
                                        </p>
                                    </CustomPaper>
                                </Grid>
                            );
                        })}
                    </Grid>
                )}
                {visibleData && (
                    <ExpandButton variant="text" size="small" onClick={() => setShowAll(!showAll)}>
                        {showAll ? "Show Less" : "Show All"}
                    </ExpandButton>
                )}
            </Stack>
        </>
    );
};

export default AnalysisNegligibleData;
